import { useCallback } from 'react';

export function useToast() {
  const notify = useCallback((message) => {
    if (message) {
      // Minimal fallback toast for now
      window.alert(message);
    }
  }, []);

  return { notify };
}
